var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.canContactTeam
    ? _c(
        "div",
        { staticClass: "sidebar__row" },
        [
          _vm.rm
            ? _c("ContactTeamItem", {
                attrs: { item: _vm.rm, "modal-key": "contactRM" }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.am
            ? _c("ContactTeamItem", {
                attrs: { item: _vm.am, "modal-key": "contactAM" }
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }